import { FC } from 'react';

import type { ProductSummaryCellMetadata, ProductSummaryScheduleRow } from './Schedule.model';
import { fieldForType } from './ScheduleRows.helper';

interface ProductSummaryScheduleRowsProps {
  scheduleRows: ProductSummaryScheduleRow[];
  metadata: ProductSummaryCellMetadata[];
}

export const ProductSummaryScheduleRows: FC<ProductSummaryScheduleRowsProps> = ({ scheduleRows, metadata }) => {
  return (
    <tbody>
      {scheduleRows.map((scheduleRow: ProductSummaryScheduleRow, rowIndex) => {
        return (
          <tr key={`scheduleRow-${rowIndex}`}>
            <td className="text-regular fw-light m-0">{rowIndex + 1}</td>
            {metadata.map((cellMetadata, cellIndex) => {
              if (cellIndex > 0) {
                const NodeComponent = fieldForType(cellMetadata.type);
                return (
                  <td key={`scheduleCell-${rowIndex}-${cellIndex}`} className="text-regular fw-light m-0">
                    <NodeComponent scheduleRow={scheduleRow} cellMetadata={cellMetadata} />
                  </td>
                );
              }
            })}
          </tr>
        );
      })}
    </tbody>
  );
};

ProductSummaryScheduleRows.displayName = 'ProductSummaryScheduleRows';
